var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("../assets/logo.svg"),"width":"120","height":"50"}})
}
var staticRenderFns = []

export { render, staticRenderFns }